export class AccountModel {
    name: string;
    stores: StoreModel[];
    emailAddress: string;
    userName: string;
    roles: Role[];
}

export class SupportedNgo {
    url: string;
    name: string;
    description: string;
    logo: string;
    active: boolean;
    image: string;
    thankyouMessage: string;
    default: boolean;
    organizationType: number;
    categories?: any;
    storeSupportedNgos: any[];
}

export class StoreFilter {
    byname: string
    bymonth: string
    mergeIdList: string
}

export class GroupFilter {
    name: string
    totalDonation: number
    total: number
    currencyTotal: number
    value: string
}

export class StorePlanFilter {
    trial: string
    bstarter: string
    b1: string
    b2: string
    b3: string
    b4: string
    b5: string
    b6: string
    b7: string
    enterprise: string
    percentual: string
}

export class StoreAdminListModel {
    id: string
    seoUrl: string
    domain: string
    mainDomain: string
    name: string
    nameContact: string
    email: string
    phone: string
    category: string;

    platform: string
    otherTools: string
    visits: number
    hasPolenScript: boolean
    hasApiKey: boolean
    purchases: number
    donations: number
    ngoLogoUrls: any

    planName: string

    activePayingUser: boolean
    active: boolean
    churn: boolean
    developmentTest: boolean
    trialActive: boolean
    trialEndDate: string
    registrationDate: string

    filterShow: boolean = true
    daysTrialLeft: number

    upSell: string
    suggestedPlan: string
    productLabel: string

    nextInvoiceDate: string
    //marca renovacoes neste mês
    renewalThisMonth: boolean;
    couponCode: any;
    referralCode: any;
}

export class StoreModel {
    id: string;
    lead: Lead;
    accountId: string;
    seoUrl: string;
    apiKey: string;
    polenVisibility: number;
    scriptValidated: boolean;
    name: string;
    logo: string;
    description: string;
    storeImage: string;
    domain: string;
    utmUrl: string;
    email: string;
    password: string;
    emailList?: any;
    commercialPhone: string;
    cellphone: string;
    companyIdentification?: any;
    whitePageList: string[];
    allowdIps?: any;
    supportedNgos: SupportedNgo[];
    maxDonationPerMonth: number;
    donationType: number;
    donationRule: number;
    updateLocalStorageOnEveryPage: boolean;
    donationPerProduct: number;
    expireHours: number;
    scrapProductName: string;
    scrapProductImage: string;
    scrapTotalPrice: string;
    scrapOrderId?: any;
    scrapOrderIdType: number;
    customFields?: any;
    isRestrictedView: boolean;
    specialItems?: any;
    storeRoles?: any;
    pagePurchaseComplete: string;
    platformId?: any;
    platformName: string;
    platformUsed?: any;
    integrationType: number;
    scaffold: boolean;
    active: boolean;
    trialActive: boolean;
    churn: boolean;
    trialActivationDate: Date;
    trialEndDate: Date;
    minutesToVerifyLastAcess: number;
    minutesToVerifyLastPurchase: number;
    registrationDate: Date;
    developmentTest: boolean;
    salesAmountDescription: string;
    category: string;

    filterShow: boolean = true
    daysTrialLeft: number
    nextInvoiceDate: Date;
    couponCode: any;
    referralCode: any;
    mrr: number
}

export class NewStore {

    constructor() {
        this.platformId = null;
        this.password = "eupolinizo";
    }

    storeUrl: string;
    storeName: string;
    document: string;
    email: string;
    name: string;
    domain: string;
    phone: string;
    logo: string;
    addres: string;
    city: string;
    state: string;
    zipcode: string;
    nameContact: string;
    causesList: string[];
    tags: string[];
    platformId: string;

    id: string;
    password: string;
    donationValue: number;
    donationRule: number;
    donationType: number;
    salesAmount: string;
}

export class Role {
    id: string;
    name: string;
    lowerCaseName: string;
}


export class Lead {
    filterShow: boolean = true

    id: string;
    email: string;
    accountId: string;
    name: string;
    domain: string;
    phone: string;
    howKnow?: any;
    password?: any;
    hashPassword?: any;
    hasPassword: boolean;
    setupCompleted: boolean;
    donationValue: number;
    acquisitionChannel: number;
    collectedType: number;
    donationType: number;
    donationRule: number;
    planType: number;
    integrationType: number;
    salesAmount: number;
    avgTicket: number;
    platformId: string;
    otherPlatform?: any;
    apiKey?: any;
    stepList?: any;
    //ngos: Ngo[];
    causes: string[];
    //customization: Customization;
    registrationDate: Date;
    updateDate: Date;

    hasPolenScript: boolean
    otherTools: string
    visits: number
    deal: number
}